import React, { FC } from "react";
import { Accordion } from "../Accordion";
import { MainDetails } from "./MainDetails";
import { LidDetails } from "./LidDetails";
import { Customization } from "../../../../types/graphql/generated";
import { StyledCustomizations } from "./index.styled";

interface CustomizationDetailsProps {
  customizations: Customization[];
  isNested?: boolean;
}

export const CustomizationDetails: FC<CustomizationDetailsProps> = ({
  customizations,
  isNested,
}) => {
  return (
    <Accordion title="Customizations" isNested={isNested}>
      <StyledCustomizations>
        <MainDetails customization={customizations[0]} isNested={isNested} />
        <LidDetails customizations={customizations} />
      </StyledCustomizations>
    </Accordion>
  );
};
